module.exports = __webpack_public_path__ + "images/homework.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/homework.jpg
 ** module id = 52
 ** module chunks = 1
 **/